const PkiCertificateDetails = () => import('client/Pki/PkiCertificateDetails/PkiCertificateDetailsPage.vue');
const PkiCertificateDistribution = () => import('client/Pki/PkiDistribution/PkiCertificateDistribution.vue');
const PkiCertificatePage = () => import('client/Pki/PkiCertificates/PkiCertificatePage.vue');
const PkiMainPanel = () => import('client/Pki/PkiMainPanel.vue');

const metaData = {
  loadLegacyStyles: false,
  title: 'Certificate Manager',
};

export default [
  {
    path: '/certificates',
    name: 'pkiConsole',
    meta: metaData,
    redirect: { name: 'All Certificates' },
    components: {
      mainPanel: PkiMainPanel,
    },
    children: [
      {
        path: 'all',
        name: 'All Certificates',
        meta: metaData,
        component: PkiCertificatePage,
      },
      {
        path: 'distribution',
        name: 'Certificates Distribution',
        meta: metaData,
        component: PkiCertificateDistribution,
      },
    ],
  },
  {
    path: '/certificates/:id/details',
    name: 'Certificate Details',
    meta: {
      loadLegacyStyles: false,
      title: 'Certificate Details',
      returnPath: '/certificates/all',
    },
    components: {
      mainPanel: PkiCertificateDetails,
    },
  },
];
